import RenderComponents from "../RenderComponents";
import React, {useEffect} from "react";
import useFieldErrors from "../../../Hooks/useFieldErrors";
import PropTypes from "prop-types";

const TabContent = (props) => {
    const {children = [], containerArrayPath, activeTab, index, setErroredTab, renderWhenVisible, isVisible} = props;
    const {errCount} = useFieldErrors(children)

    useEffect(() => {
        setErroredTab(index, errCount)
    }, [errCount]);

    if(renderWhenVisible && !isVisible) return <></>

    return (
        children.map((item, itemIndex) => (
            <RenderComponents
                key={itemIndex}
                element={item}
                containerArrayPath={containerArrayPath}
                actionsContext={{
                    isVisibleTab: activeTab === index
                }}
            />
        ))
    )
}

export default TabContent

TabContent.propTypes = {
    children: PropTypes.array,
    containerArrayPath: PropTypes.string,
    activeTab: PropTypes.number,
    index: PropTypes.number,
    setErroredTab: PropTypes.func.isRequired,
}